import { render } from "./02_Afordable.vue?vue&type=template&id=ee9e4af0&scoped=true"
import script from "./02_Afordable.vue?vue&type=script&lang=js"
export * from "./02_Afordable.vue?vue&type=script&lang=js"

import "./02_Afordable.vue?vue&type=style&index=0&id=ee9e4af0&lang=css"
import "./02_Afordable.vue?vue&type=style&index=1&id=ee9e4af0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee9e4af0"]])

export default __exports__